import { ReactNode, useState, useRef, useEffect } from "react";
import classNames from "classnames";
import "./ContextMenu.scss";
import SVG from "shared/SVG";
import { SVG_ENUM } from "enums";

interface ContextMenuType {
  className?: string;
  children: ReactNode;
  data?: any;
  items: {
    name: any;
    disabled?: boolean;
    svg?: SVG_ENUM;
    action: (data: any) => void;
  }[];
  position?: "top" | "bottom" | "left" | "right";
}

const ContextMenu = ({
  data,
  children,
  items,
  position = "left",
  className,
}: ContextMenuType) => {
  const [isActive, setIsActive] = useState(false);
  const contextMenuRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (
      contextMenuRef.current &&
      !contextMenuRef.current.contains(event.target as Node)
    ) {
      setIsActive(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const contextMenuClass = classNames(
    "context-menu",
    className,
    `context-menu--${position}`,
    {
      "context-menu--active": isActive,
    },
  );
  return (
    <div className="context-menu__wrapper">
      <div className="context-menu__content">
        <div
          className={`context-menu__trigger ${
            isActive ? "context-menu__trigger--disable" : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            setIsActive(true);
          }}
        >
          {children}
        </div>
        <div className={contextMenuClass} ref={contextMenuRef}>
          {items.map((item: any) => {
            return (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  if (!item.disabled) {
                    item.action(data);
                    setIsActive(false);
                  } else {
                    setIsActive(false);
                  }
                }}
                className={`context-menu__item 
                  ${item.disabled ? "context-menu__item--disabled" : ""}
                  ${
                    item.svg === SVG_ENUM.TRASH
                      ? "context-menu__item--delete"
                      : ""
                  }
                  `}
                key={item.name}
              >
                {item.svg ? (
                  <SVG className="context-menu__icon" type={item.svg} />
                ) : null}
                {item.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ContextMenu;
